import React from "react";

import { useTranslation } from "react-i18next";
import "./styles.less";

export const PartnerSystem = () => {
  const { t } = useTranslation();
  const systemData = [
    {
      img: "//files.authing.co/authing-website/system-canal.svg",
      title: t("partner.system.item1.title"),
      text: t("partner.system.item1.text"),
      position: "left",
    },
    {
      img: "//files.authing.co/authing-website/system-ecology.svg",
      title: t("partner.system.item2.title"),
      text: t("partner.system.item2.text"),
      position: "center",
    },
    {
      img: "//files.authing.co/authing-website/system-serve.svg",
      title: t("partner.system.item3.title"),
      text: t("partner.system.item3.text"),
      position: "right",
    },
  ];
  return (
    <div>
      <section className="partner-system">
        <div className="system-title">{t("partner.system.title")}</div>
        <div className="system-card-warp">
          {systemData.map((item, index) => (
            <div className={`system-card ${item.position}`} key={index}>
              <div className="card-img">
                <img src={item.img} alt="authing" />
              </div>
              <div className="card-title">{item.title}</div>
              <div className="card-content">{item.text}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};
